export const maskOptions = ['Nenhuma', 'Máscara fina (pano, cirúrgica)', 'Máscara grossa (N-95)'];

export const apiMaskOptions = ['NONE', 'THIN', 'THICK'];

export const covidOptions = ['Sim', 'Não', 'Não deseja declarar ou não sabe'];

export const apiCovidOptions = ['TRUE', 'FALSE', 'UNKNOWN'];

export const sampleTypeOptions = ['Paciente', 'Teste', 'Controle', 'Pós-covid'];

export const apiSampleTypeOptions = ['PATIENT', 'TEST', 'CONTROL', 'AFTERCOVID'];

export const internationReasonOptions = ['Sim', 'Não'];

export const apiInternationReasonOptions = [true, false];

export const internationLocationOptions = ['Enfermaria', 'UTI'];

export const apiInternationLocationOptions = ['NURSERY', 'ICU'];
